export default {
  itemStyle: {
    normal: {
      areaColor: '#eee',
      borderColor: '#444',
      borderWidth: 0.5
    },
    emphasis: {
      areaColor: 'rgba(255,215,0,0.8)',
      borderColor: '#444',
      borderWidth: 1
    }
  },
  label: {
    normal: {
      textStyle: {
        color: '#000'
      }
    },
    emphasis: {
      textStyle: {
        color: 'rgb(100,0,0)'
      }
    }
  }
};